const muiLicense =
  "6b999dd87dcc2f76c47ebceab7aef029Tz0xMjIyNDAsRT0xNzk1NTY0Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=";

export default muiLicense;
